import type { JSX } from 'react';
import { useReveal } from '@hooks/useReveal';

interface RevealWrapperProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}

export default function RevealWrapper({ children, delay, className = '' }: RevealWrapperProps): JSX.Element {
  const ref = useReveal();
  const delayClass = delay !== undefined ? `reveal--delay-${String(delay)}` : '';

  return (
    <div ref={ref} className={`reveal ${delayClass} ${className}`.trim()}>
      {children}
    </div>
  );
}
